import React, { useEffect, useState } from "react";
import { object, bool } from "prop-types";

import FourProfileCards from "../FourProfileCards";
import { fetchEntityData } from "../../utils/entity-data";
import { fetchTrendingPeople } from "../../../../api/utils";
import { useSelector } from "react-redux";
import { get } from "lodash";

const ProfileRanking = ({ collection, storyPage = false, config, story = {} }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const trendingPeopleData = qtState?.data?.homeEntities?.TrendingPeople || {};
  const interval = trendingPeopleData?.interval || "14";
  const cdnImage = `https://${config?.["cdn-image"]}`;
  const entityData = storyPage ? collection : collection.entityData;
  const trendingPeople = !storyPage && collection?.["associated-metadata"]?.layout === "TrendingPeople";

  const [entityDetails, setEntityDetails] = useState([]);

  const { name, buttonText, buttonLink, year, showRanking, yearId, slug } = entityData || {};

  const logoName = {
    "forty-under-forty-snapshot-year": "/images/logos-square/40-under-40.png",
    "most-powerful-women-snapshot-year": "/images/logos-square/mpw-logo.png",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (trendingPeople) {
          const data = await fetchTrendingPeople(`${interval}`);
          setEntityDetails(data);
        } else {
          const data = await fetchEntityData(slug, yearId);
          setEntityDetails(data);
        }
      } catch (err) {
        console.error("Failed to fetch entity details", err);
        setEntityDetails([]);
      }
    };

    fetchData();
  }, [slug, yearId, trendingPeople]);

  if (!entityDetails.length) return null;
  if (trendingPeople && entityDetails.length < 4) return <div style={{ marginBottom: "-50px" }} />;

  return (
    <FourProfileCards
      options={entityDetails}
      heading={name}
      logoLink={logoName[entityData?.slug]}
      buttonText={buttonText}
      buttonLink={buttonLink}
      year={year}
      showRanking={showRanking}
      storyPage={storyPage}
      cdnImage={cdnImage}
      story={story}
      config={config}
      trendingPeople={trendingPeople}
    />
  );
};

ProfileRanking.propTypes = {
  collection: object,
  storyPage: bool,
};

export default ProfileRanking;
